import { getCookie } from '../cookies';
import { errorHandlers, getAuthToken } from '../helpers';

export const fetchData = async ({
    url,
    method = 'GET',
    body = {},
    permission = null,
    externalLink = false,
}: {
    url: string;
    method: string;
    body: any;
    permission?: string | null;
    externalLink?: boolean;
}): Promise<{ data: any; error: any; status?: number; code?: string }> => {
    const options: {
        method: string;
        headers?: any;
        body?: string;
    } = {
        method,
    };

    if (!externalLink) {
        const token = await getAuthToken();

        options.headers = {
            'Content-Type': 'application/json',
            'allow-control-allow-origin': '*',
            'x-user-token': token,
            'x-user-workspace': getCookie('helio-workspace')?.id,
        };
    }

    if (['POST', 'PUT', 'PATCH'].includes(method)) {
        options.body = JSON.stringify(body);
    }

    if (permission) {
        options.headers['x-user-permission'] = permission;
    }

    try {
        // eslint-disable-next-line no-undef
        const response = await fetch(url, options);

        if (!response.ok) {
            // Preserve the HTTP status and any machine-readable error code
            // (e.g. auth-api's `legacy_decommissioned`) for callers that need
            // to branch on it, without changing the existing `{ data, error }`
            // contract. `clone()` so errorHandlers can still read the body.
            let code: string | undefined;

            try {
                const parsed = (await response.clone().json()) as {
                    detail?: { code?: string } | string;
                };

                if (parsed?.detail && typeof parsed.detail === 'object') {
                    code = parsed.detail.code;
                }
            } catch {
                // Body is not JSON / already consumed; leave code undefined.
            }

            return { error: await errorHandlers(response), data: null, status: response.status, code };
        }

        const data = await response.json();

        return { error: null, data };
    } catch (error) {
        return { error: errorHandlers(error), data: null };
    }
};
